import { DIR } from '@/services/localhost';
import { split } from '@/services/useful';


    export function SESSION(name, $text='')
    {
        if($text){
            localStorage.setItem(`${name}_${DIR()}`, $text);
            return $text;

        } else {
            return localStorage.getItem(`${name}_${DIR()}`);
        }
    }

    export function SESSION_REMOVE(name)
    {
        localStorage.removeItem(`${name}_${DIR()}`);
    }


    // API
        export function SESSION_API(data, url)
        {
            // DIAGNOSTICOS_INDEX
                if(split(url, `/diagnosticos_index/`) || split(url, `/diagnosticos_store/`)){
                    data.SESSION = {
                        diretores: SESSION(`diretores`)
                    };
                }
            // DIAGNOSTICOS_INDEX

            return data;
        }
    // API
